import gql from "graphql-tag"

const deleteCustomerAccount = gql`    
    mutation 
    deleteCustomerAccount {
        deleteCustomerAccount
    }        
`

const createCustomerCase = gql`
    mutation
    createCustomerCase ($caseType: String!, $file: Upload!, $data: CustomerCaseInput!) {
        createCustomerCase (caseType: $caseType, file: $file, data: $data)
    }
`

export {
    deleteCustomerAccount,
    createCustomerCase
}